module.exports = __webpack_public_path__ + "images/shop/favicon-kfz24/android-chrome-192x192.png";